<template>
    <div class="mode-select">
      <img src="https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/banner%201%E7%89%88.png" class="banner">
      <img src="https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E5%AF%B9%E6%88%98%E6%A8%A1%E5%BC%8F.png" class="banner2">
      <div class="mode-buttons">
        <div class="tabs">
          <div v-for="item in list" :key="item.id" class="tab" :style="{background:'url('+item.imgurl+') no-repeat','background-size':'100%'}" @click="startPve(item.id)"></div>
        </div>
        <!-- 人机对战：直接跳转到下棋页面，传入 mode=pve 与棋子颜色参数 -->
        <!-- <button @click="startPve(1)">人机对战 - 执黑</button>
        <button @click="startPve(2)">人机对战 - 执白</button> -->
        <!-- 人人对战：跳转到桌台大厅 -->
        <div class="button">
          <div class="button1" @click="goTocreTableRoom"></div>
          <div class="button2" @click="goToTableRoom"></div>
        </div>
      </div>
      <div class="glist">
        <div class="item-wrapper" v-for="item in tablist" :key="item.id">
          <div 
            class="item" 
            :style="{background:'url('+item.imgurl+') no-repeat','background-size':'100%'}" 
            @click="change(item.id)">
          </div>
          <div v-if="item.badge" class="badge">{{ item.badge }}</div>
        </div>
      </div>

      <van-popup
        v-model="showtasksrDialog"
        round
        position="bottom"
        :style="{maxWidth: '430px', background: 'transparent'}"
      >
        <!-- <img src="https://oss.mcloud.moveclub.cn/2025/hu_game/%E5%BC%B9%E7%AA%97top.png" class="cardtop"> -->
        <img @click="closepop" src="https://oss.mcloud.moveclub.cn/2025/hu_game/%E5%85%B3%E9%97%AD.png" class="cardtop2">
        <div class="popst">
            <div class="cardlist" v-for="item in tasklist" :key="item.id">
                <div class="card" @click="choosego(item.id)">
                    <div style="display: flex;">
                      <div class="left">
                          <img class="cardimg" :src="item.img"/>
                      </div>
                      <div class="right">
                          <div class="text1">{{item.text1}}</div>
                          <div class="middle">
                              <div class="text2">{{item.text2}}</div>
                          </div>
                      </div>
                      <div class="text3">{{item.text3}}{{item.text4}} 
                        <span v-if="item.id==1">({{steps}}/4)</span>
                      </div>
                    </div>
                </div>
            </div>
        </div>
      </van-popup>
      <van-popup
        v-model="showUploadRuleDialog"
        round
        position="center"
        :style="{ width: '70%', padding: '20px', background: '#FFFFFF' }"
      >
        <div class="upload-rule-container">
          <div class="rule-title">上传照片</div>
          <img @click="closepop" src="https://oss.mcloud.moveclub.cn/2025/hu_game/1013%E5%85%B3%E9%97%AD.png" class="cardtop3">
          <div class="rule-content">
            <div class="rule-item">
              <img @click="confirmUpload" class="icon" src="https://oss.mcloud.moveclub.cn/2025/hu_game/1013%E4%B8%8A%E4%BC%A0.png">
              <div>  
                <div class="text">拍摄跑步运动记录</div>
                <div class="rule-desc">上传跑步运动结束屏幕照片，</div>
                <div class="rule-desc">或者是运动手环的运动记录</div>
              </div>
            </div>
            <div class="example">
              <div class="example-text">示例：</div>
              <img src="https://oss.mcloud.moveclub.cn/2025/hu_game/exam%E5%8A%A8%E6%84%9F%E5%8D%95%E8%BD%A6.png" class="example-img" />
            </div>
          </div>
        </div>
      </van-popup>
      <input
        ref="fileInput" 
        type="file" 
        accept="image/*" 
        @change="handleFileUpload" 
        style="display: none;"
      />
    </div>
  </template>
  
  <script>
  import { Popup,Toast } from 'vant';
  import axios from 'axios'
  export default {
    name: 'Game',
    components: {
      vanPopup: Popup,
      vanToast: Toast
    },
    data() {
      return {
        list: [
          {
            id: 1,
            imgurl: 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E6%89%A7%E7%99%BDnew.png'
          },
          {
            id: 2,
            imgurl: 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E6%89%A7%E9%BB%91new.png'
          }
        ],
        tablist: [
          {
            id: 1,
            imgurl: 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E8%A7%84%E5%88%99.png'
          },
          {
            id: 2,
            imgurl: 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E6%8E%92%E8%A1%8C.png'
          },
          {
            id: 3,
            imgurl: 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E6%8A%BD%E5%A5%96.png'
          },
          {
            id: 4,
            imgurl: 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E9%9B%86%E9%81%93%E5%85%B7.png',
            badge: '0'
          }
        ],
        tasklist: [
          { 
              img: 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E6%AD%A5%E6%95%B0%402x.png',
              text1: '微信步数兑换',
              text2: '5000步=1个减速器，上限20000步/日',
              text3: '0',
              text4: '/20000步',
              id: 1
          },
          {
              img: 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E6%89%93%E5%8D%A1%402x.png',
              text1: '上传跑步打卡',
              text2: '上传跑步截图1次=1个减速器，上限2次/日',
              text3: '0',
              text4: '/2次',
              id: 2
          },
        ],
        userinfo: {},
        showUploadRuleDialog: false,
        showtasksrDialog: false,
        isSubmitting: false,
        steps: 0,
      }
    },
    mounted() {
      this.share()
      const userInfoStr = localStorage.getItem('userinfo');
      console.log(userInfoStr,'userInfoStr');
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          this.userinfo = userInfo;
          this.getmyprops()
          this.getgameInfo();
        } catch (e) {
          console.error('解析用户信息失败:', e);
        }
      }
    },
    methods: {
      getmyprops() { 
        axios.get('/mapi/game/myprops', {
          params: {
            urid: this.userinfo.urid,
            token: this.userinfo.token,
          }
        })
        .then(res => {
          if(res.data.status == 200){
            this.tablist[3].badge = res.data.data[0].total
          }
        })
      },
      async choosego(index){
        const task = this.tasklist.find(item => item.id === index);
        switch (index) {
          case 1:
            if (this.isSubmitting) {
              console.log('请求正在处理中，请稍后再试');
              return;
            }
            this.isSubmitting = true;
            axios.post('/mapi/game/submitresult',{
              urid: this.userinfo.urid,
              gid: this.userinfo.gid,
              gameid: 9,
              score: 1
            }).then((res) => {
              if (res.data.status == 200) {
                this.getgameInfo();
                this.getmyprops();
              } else {
                Toast(res.data.message);
              }
            }).finally(() => {
              this.isSubmitting = false;
            });
            break;
          case 2:
            // if (task && !task.isdown) {
            //   return;
            // }
            this.showUploadRuleDialog = true
            break;
          default:
            break;
        }
      },
      closepop(){
        this.showUploadRuleDialog = false,
        this.showtasksrDialog = false
      },
      getgameInfo(){
        axios.post('/mapi/game/gameview',
        { gameid: 8,
          urid: this.userinfo.urid,
          gid: this.userinfo.gid,
          token: this.userinfo.token
        }).then((res) => { 
          if(res.data.status == 200){
            res.data.data.gamelist.forEach(element => {
              if(element.num == null){
                element.num = 0;
                element.isdown = true;
              } else {
                if(element.num == 0){
                  element.isdown = false;
                  element.num = element.daylimit - element.num;
                } else {
                  element.isdown = true;
                  element.num = element.daylimit - element.num;
                } 
              }
            });
            this.tasklist[0].text3 = res.data.data.gamelist[0].num;
            this.tasklist[0].isdown = res.data.data.gamelist[0].isdown;
            this.tasklist[1].text3 = res.data.data.gamelist[1].num;
            this.tasklist[1].isdown = res.data.data.gamelist[1].isdown;
            console.log(res.data.data.gamelist,'tasklist[123]');
            this.steps = res.data.data.gamelist[0].prop_num || 0;
          } else {
            Toast(res.message);
          }
        });
      },
      async confirmUpload(){
        const bikeResult = await this.uploadimg();
        if (bikeResult && bikeResult.url) {
          axios.post('/mapi/game/submitresult',{
            urid: this.userinfo.urid,
            gid: this.userinfo.gid,
            scoreurl: bikeResult.url,
            gameid: 10,
            score: 1
          }).then((res) => {
            if (res.data.status == 200) {
              Toast("上传成功");
              this.getgameInfo();
              this.getmyprops();
            } else {
              Toast(res.message);
            }
          });
        }
        this.showUploadRuleDialog = false;
        
      },
      // 图片上传
      async uploadimg(){
        this.$refs.fileInput.click();
        // fileInput.value.removeAttribute('capture');
        return new Promise((resolve) => {
          // 设置全局回调函数
          window.uploadCallback = (result) => {
            resolve(result);
            delete window.uploadCallback; // 清理回调函数
          };
        });
      },
      // 处理文件上传
      async handleFileUpload(event){
        const file = event.target.files[0];
        if (!file) {
          if (window.uploadCallback) window.uploadCallback(null);
          return;
        }
        // 检查文件类型
        if (!file.type.startsWith('image/')) {
          console.error('请选择图片文件');
          if (window.uploadCallback) window.uploadCallback(null);
          return;
        }
        // 检查文件大小
        if (file.size > 5 * 1024 * 1024) {
          console.error('文件大小不能超过5MB');
          if (window.uploadCallback) window.uploadCallback(null);
          return;
        }
        try {
          // 获取OSS签名信息
          const ossRes1 = await axios.post('/mapi/api/oss-signature', {
            token: this.userinfo.token,
            urid: this.userinfo.urid,
            gid: this.userinfo.gid
          });
          const ossRes = ossRes1.data
          if (ossRes.status !== 200) {
            console.error('获取OSS签名信息失败');
            if (window.uploadCallback) window.uploadCallback(null);
            return;
          }
          const { host, policy, signature, accessid, dir } = ossRes.data;
          const formData = new FormData();
          const keys = dir + Date.now() + '-' + file.name //时间戳防重复
          formData.append('key', keys);
          formData.append('policy', policy);
          formData.append('OSSAccessKeyId', accessid);
          formData.append('signature', signature);
          formData.append('file', file);
          // 上传到OSS
          const response = await fetch(host, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            const fileUrl = host + '/' + keys;
            console.log('图片上传成功:', fileUrl);
            // 调用回调函数返回结果
            if (window.uploadCallback) {
              window.uploadCallback({ url: fileUrl });
            }
            return { url: fileUrl };
          } else {
            console.error('图片上传失败:', response.statusText);
            if (window.uploadCallback) window.uploadCallback(null);
            return null;
          }
        } catch (error) {
          console.error('图片上传出错:', error);
          if (window.uploadCallback) window.uploadCallback(null);
          return null;
        } finally {
          // 清空文件
          event.target.value = '';
        }
      },

      share() {
        var url = 'https://game.gomoku.mvsports.cn/mode'
          var shareConf = {
            title: '桌台大厅',
            path:
              '/pages/webview/index?src=' + url,
          }
          wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) });
      },
      startPve(color) {
        this.$router.push({ path: '/game', query: { mode: 'pve', color: color } });
      },
      goTocreTableRoom() {
        this.$router.push({ path: '/table', query: { create: 'true' } });
      },
      goToTableRoom() {
        this.$router.push('/table');
      },
      change(type) {
        switch(type) {
          case 1:
            window.location.href = 'https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/rule.png'
            break
          case 2:
            window.location.href = 'https://bk.h5.movecloud.cn/xh/rank25/10655' //活动id
            break
          case 3:
            window.location.href = 'https://bk.h5.movecloud.cn/activity/luckdraw/1355' //抽奖id
            break
          case 4:
            this.showtasksrDialog = true
            break
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .mode-select {
    text-align: center;
    padding: 302px 22px 0;
    background: url(https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/bg2.png) no-repeat;
    background-position: center 204px;
    background-size: cover;
    min-height: 100vh;
    box-sizing: border-box;
  }
  .mode-select .banner{ 
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 220px;
  }
  .mode-select .banner2{ 
    position: absolute;
    top: 236px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 54px;
  }
  .mode-buttons .tabs{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 10px;
  }
  .mode-buttons .tabs .tab{
    width: 140px;
    height: 192px;
    background-size: contain;
  }
  .mode-buttons .button {
    position: relative;
    width: 100%;
    height: 122px;
    background: url(https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E5%A5%BD%E5%8F%8B%E5%AF%B9%E6%88%98.png) no-repeat;
    background-size: 100% 100%;
  }
  .mode-buttons .button .button1 {
    position: absolute;
    top: 50%;
    left: 38%;
    transform: translate(-50%, -50%);
    width: 32%;
    height: 40px;
    background: url(https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E5%88%9B%E5%BB%BA%E6%A1%8C%E5%8F%B0.png) no-repeat;
    background-size: 100% 100%;
  }
  .mode-buttons .button .button2 {
    position: absolute;
    top: 50%;
    left: 72%;
    transform: translate(-50%, -50%);
    width: 32%;
    height: 40px;
    background: url(https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E5%8A%A0%E5%85%A5%E6%A1%8C%E5%8F%B0.png) no-repeat;
    background-size: 100% 100%;
  }
  .glist{
    display: flex;
    justify-content: space-around;
    margin-top: 32px;
    padding: 0 2px;
  }
  .glist .item-wrapper {
    position: relative;
  }
  .glist .item{
    width: 75px;
    height: 75px;
  }
  .glist .badge {
    position: absolute;
    top: 1px;
    right: 1px;
    background-color: #ff0000;
    color: white;
    border-radius: 10px;
    padding: 2px 6px;
    font-size: 12px;
    z-index: 10;
  }
  .mode-select .upload-rule-container {
    .rule-title {
      font-size: 20px;
      color: #000000;
      text-align: center;
      margin-bottom: 20px;
      font-weight: 500;
    }
    .cardtop3{
      width: 28px;
      height: 28px;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .rule-content {
      .rule-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        justify-content: center;
        .icon {
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;
        }
        
        .text {
          font-size: 15px;
          color: #000000;
          line-height: 1.5;
          font-weight: 500;
          margin: 0 0 4px 0;
        }
      }
      
      .rule-desc {
        font-size: 13px;
        color: #666;
        line-height: 1.3;
      }
      
      .example {
        display: flex;
        justify-content: center;
        margin: 18px 0 0 0;
        .example-text {
          font-size: 13px;
          color: #333333;
          margin: 2px 10px 0 0;
        }
        
        .example-img {
          width: 120px;
          height: 75px;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
      }
    }
    
  }
  .mode-select .cardtop{
      width: 100%;
      height: 128px;
      position: absolute;
      top: 0px;
      left: 0;
  }
  .mode-select .cardtop2{
    width: 36px;
    height: 36px;
    position: absolute;
    top: -2px;
    right: 12px;
  }
  .mode-select .popst{
    padding: 76px 0 18px 0;
    background: url('http://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E4%BB%BB%E5%8A%A1%E5%BC%B9%E7%AA%97.png') no-repeat;
    background-size: cover;
      .cardlist{ 
          display: flex;
          flex-direction: column;
          margin: 0px 10px;
      }
      .card{
          background: url('https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/eachcard.png') no-repeat;
          background-size: 98% 100%;
          display: flex;
          align-items: center;
          height: 98px;
          padding: 0 12px;
          justify-content: space-between;
          margin: 4px 0;
          .left{
              width: 52px;
              height: 52px;
              margin: 0 8px 0 0; 
              padding: 0px 0 0 28px;
              .cardimg{
                  width: 100%;
                  height: 100%;
              }
          }
          .right{ 
              width: 116px;
              height: 45px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              gap: 6px;
              padding: 4px 0 0 0;
              .text1{
                  font-size: 15px;
                  color: #9A5821;
                  font-weight: 600;
                  text-align: left;
              }
              .middle{ 
                display: flex;
              }
              .text2{ 
                opacity: 0.65;
                font-size: 11.5px;
                color: #AE7E1E;
                font-weight: 400;
                text-align: left;
              }
          }
          .text3{
            font-size: 12px;
            color: #FA6400;
            font-weight: 400;
            text-align: end;
            width: 118px;
            white-space: nowrap;
          }
          .cardbtn{
            background: #030303;
            border-radius: 30px;
            padding: 10px 16px;
            font-size: 14px;
            color: #FFFFFF;
            font-weight: 400;
            white-space: nowrap;
          }
          .completed {
            background: #E5E5E5;
          }
      }
  }
  </style>
  